import React from "react";

import { Alert } from "react-bootstrap";
import routes from "startups/routes";
import { SuccessMessage, ErrorList } from "shared/components";
import OrderUnitsList from "./OrderUnitsList";

const OrderUnitsOverview = props => {
  const { orderUnits, hasProducts, removeOrderUnitFn } = props;

  if (!hasProducts) {
    return (
      <OrderUnitsOverviewLayout {...props}>
        <NoProductsOrderUnitsOverview />
      </OrderUnitsOverviewLayout>
    );
  }

  const activeStandardOrderUnits = orderUnits.filter(
    orderUnit => orderUnit.isLive && orderUnit.orderUnitType === "Standard",
  );
  const activeSpecialOrderUnits = orderUnits.filter(
    orderUnit => orderUnit.isLive && orderUnit.orderUnitType !== "Standard",
  );
  const inactiveOrderUnits = orderUnits.filter(orderUnit => !orderUnit.isLive);

  return (
    <OrderUnitsOverviewLayout {...props}>
      <h4>Meine aktiven Standard-Bestelleinheiten</h4>
      {activeStandardOrderUnits.length > 0 ? (
        <OrderUnitsList
          orderUnits={activeStandardOrderUnits}
          removeOrderUnitFn={removeOrderUnitFn}
        />
      ) : (
        <EmptyActiveStandardOrderUnitsList />
      )}

      <h4>Meine aktiven Displays & Aktionen</h4>
      {activeSpecialOrderUnits.length > 0 ? (
        <OrderUnitsList
          orderUnits={activeSpecialOrderUnits}
          removeOrderUnitFn={removeOrderUnitFn}
        />
      ) : (
        <EmptyActiveSpecialOrderUnitsList />
      )}

      <If condition={inactiveOrderUnits.length > 0}>
        <h4>Meine inaktiven Bestelleinheiten, Displays & Aktionen</h4>
        <OrderUnitsList
          orderUnits={inactiveOrderUnits}
          removeOrderUnitFn={removeOrderUnitFn}
        />
      </If>
    </OrderUnitsOverviewLayout>
  );
};

const OrderUnitsOverviewLayout = props => {
  return (
    <div>
      <SuccessMessage message={props.submitSuccessMessage} />
      <ErrorList errorMessages={props.submitErrorMessages} />
      {props.children}
    </div>
  );
};

const NoProductsOrderUnitsOverview = () => {
  return (
    <div className="order-units-list-overview">
      <Alert>
        Du musst zuerst ein Produkt anlegen, bevor Du es einer Bestelleinheit
        zuordnen kannst.
      </Alert>
      <div>
        <a href={routes.newStartupsProductPath()} className="btn btn-secondary">
          Jetzt Produkt erstellen
        </a>
      </div>
    </div>
  );
};

const EmptyActiveStandardOrderUnitsList = () => {
  return (
    <div className="order-units-list-overview">
      <Alert>Bisher keine aktiven Standard-Bestelleinheiten.</Alert>
      <div>
        <a
          href={routes.newStartupsOrderUnitPath()}
          className="btn btn-secondary"
        >
          Neue Bestelleinheit
        </a>
      </div>
    </div>
  );
};

const EmptyActiveSpecialOrderUnitsList = () => {
  return (
    <div className="order-units-list-overview">
      <Alert>Bisher keine aktiven Displays oder Aktionen.</Alert>
      <div>
        <a
          href={routes.newStartupsOrderUnitPath()}
          className="btn btn-secondary"
        >
          Neue Bestelleinheit
        </a>
      </div>
    </div>
  );
};

export default OrderUnitsOverview;
